import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
//import { UserContext } from "../store/userContext";
import http from "../Services/httpService";
//import queryString from 'query-string';
import { toast } from "react-toastify";

export default function AdminLogin() {
    let navigate = useNavigate();
    const [searchParams] = useSearchParams();
    //const { reCreate } = useContext(UserContext);
    useEffect(() => {
        //console.log('location',location);
        //let params = queryString.parse(location.search);
        //console.log('params', params);
        const token = searchParams.get('token');
        if (token != "") {
            http.setLocalJwt(token);
            // reCreate();
            navigate('/main', { replace: true })
        } else {
            http.logout();
            toast.error('پارامتر های ورودی کامل نیست', { theme: "colored" });
            navigate('/login');
        }
    }, []);


    return (
        <>
        </>
    );

}
